import type { AvatarsSubtitleStyle } from '../../../modules/avatars/types/subtitles';
import { MACRO_AVATARS_SUBTITLE_STYLE } from '../../MACRO/avatars/subtitles';

/**
 * TEST reusa el mismo estilo que MACRO por ahora (sandbox del feature).
 * Cuando aparezcan clientes con estilos propios, cada uno tendrá su config.
 */
export const TEST_AVATARS_SUBTITLE_STYLE: AvatarsSubtitleStyle = MACRO_AVATARS_SUBTITLE_STYLE;
